<template>
  <v-card-item>
    <template v-slot:prepend>
      <v-icon class="header-icon" :icon="icon" />
    </template>
    <v-card-title :data-cy="dataCy">
      {{ $t(`map.deviceAlerts.${title}`) }}
    </v-card-title>
    <template v-slot:append>
      <v-switch
        v-if="showSwitch"
        v-model="localEnabled"
        v-bind:label="$t('map.deviceAlerts.fields.enabled')"
        color="primary"
        density="compact"
        hide-details
        data-cy="addEnabled"
      />
    </template>
  </v-card-item>
</template>

<script lang="ts">
import { defineComponent, toRaw, type PropType } from 'vue'
import type { TriggerDraft } from '../dialogs/DeviceAlertsDialog.vue'

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<TriggerDraft>,
      required: true
    },
    title: {
      type: String as PropType<string>,
      required: true
    },
    icon: {
      type: String as PropType<string>,
      required: true
    },
    dataCy: {
      type: String as PropType<string>,
      required: true
    }
  },

  emits: ['update:modelValue'],

  computed: {
    localEnabled: {
      get(): boolean {
        return this.modelValue.enabled ?? true
      },
      set(val: boolean) {
        const update = structuredClone(toRaw(this.modelValue))
        update.enabled = val
        this.$emit('update:modelValue', update)
      }
    },
    showSwitch(): boolean {
      return this.title === 'editTitle' || this.title === 'addTitle'
    }
  }
})
</script>

<style lang="scss" scoped>
.v-switch {
  margin-top: -8px;
  margin-bottom: -8px;
}
</style>
